import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { Spinner } from '@/components/ui/Spinner';
import type { Role } from './types';

interface Props {
  children: ReactNode;
  requireRole?: Role;
}

export function ProtectedRoute({ children, requireRole }: Props) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen text-text-muted">
        <Spinner size={24} />
      </div>
    );
  }
  if (status === 'guest' || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
